var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-search__header"},[_c('div',{staticClass:"p-search__header-body"},[_c('div',{staticClass:"p-search__search-wrapper"},[_c('input',{staticClass:"p-search__search",attrs:{"type":"search","placeholder":_vm.$t('tag_keyword_search')},domProps:{"value":_vm.queryText},on:{"input":function (e) {
            _vm.dirty = true;
            _vm.handleOnInputChangeWrapper(e);
          },"change":function (e) {
            _vm.dirty = true;
            _vm.handleInputChange(e);
          },"keydown":function (e) { return _vm.modifiers.enter(_vm.handleOnEnter); },"blur":function (e) {
            if (_vm.dirty) {
              _vm.handleOnBlur(e);
            }
          }}}),_c('button',{staticClass:"p-search__search-submit is-disabled",attrs:{"type":"submit","disabled":""}},[_vm._v("Search")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }